import { useCallback, useEffect, useState } from "react";
import { fetchPaymentStatusRazorpay } from "../services/razorpayService";

const parsePlanStatus = (value) => parseInt(value, 10) || 0;

const isActivePayment = (value) => Number(value) === 1;

export default function usePaymentStatus() {
  const [planType, setPlanType] = useState(0);
  const [isPaymentActive, setIsPaymentActive] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchPaymentStatusRazorpay();
      setPlanType(parsePlanStatus(data?.plan_status));
      setIsPaymentActive(isActivePayment(data?.payment_status));
      setPaymentStatus(data ?? null);
      setError(null);
      return data;
    } catch (err) {
      setPlanType(0);
      setIsPaymentActive(false);
      setPaymentStatus(null);
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    planType,
    isPaymentActive,
    paymentStatus,
    loading,
    error,
    refresh,
  };
}
